// Preserve legacy row rendering and keys during migration.
/* eslint-disable arrow-body-style, react/no-array-index-key, prefer-template */
import type { SetPositionCategoryType } from 'utils/apiList/setPosition'
import { memo } from 'react'
import styled from 'styled-components'
import { SystemIcon, RowSetPositionCategory } from 'components'

interface TableSetPositionCategoryPropsType {
  data?: SetPositionCategoryType[]
  allProductData?: Partial<SetPositionCategoryType>
  handleChangeActive?: unknown
  handleClickDetail?: unknown
  handleClickUpdate?: unknown
  isAllowedForSelectCategory?: boolean
}

function TableSetPositionCategory({
  data,
  allProductData,
  handleChangeActive: _handleChangeActive,
  handleClickDetail: _handleClickDetail,
  handleClickUpdate: _handleClickUpdate,
  isAllowedForSelectCategory,
}: TableSetPositionCategoryPropsType) {
  return (
    <>
      <Container>
        <thead>
          <Tr>
            <Th ratio="4">
              SUB-KATEGORY
              <SystemIcon iconName="up-and-down" fontSize="smallest" className="ml-3" />
            </Th>
            <Th ratio="3">jumlah produk</Th>
            <Th ratio="2">AKSI</Th>
          </Tr>
        </thead>
        <tbody>
          {allProductData && (
            <RowSetPositionCategory
              data={allProductData}
              isAllowedForSelectCategory={isAllowedForSelectCategory}
            />
          )}
          {data?.map((items, index) => {
            return (
              <RowSetPositionCategory
                data={items}
                isAllowedForSelectCategory={isAllowedForSelectCategory}
                key={'dad' + index + 'set'}
              />
            )
          })}
        </tbody>
      </Container>
    </>
  )
}

export default memo(TableSetPositionCategory)

const Container = styled.table`
  width: 100%;
`
const Tr = styled.tr`
  display: flex;
  padding: 16px 32px;
  background-color: ${({ theme: { colors } }) => colors.tableHead};
`
const Th = styled.th<{ ratio: string }>`
  color: ${({ theme: { colors } }) => colors.grey};
  /* font-weight: ${({ theme: { fontWeights } }) => fontWeights.light}; */
  font-size: ${({ theme: { fontSizes } }) => fontSizes.smaller};
  flex: ${({ ratio }) => ratio};
  text-align: start;
`
